import { useAppDispatch, useTypedSelector } from "@/config/configureAppStore";
import { MIXPANEL_EVENTS } from "@/constants/mixpanel";
import { CONTACT_SALES_URL } from "@/constants/routeUrls";
import {
  setCalendlyDialog,
  setCalendlyDialogProps
} from "@/reducers/slices/dialogSlice/dialogSlice";
import { trackMixpanelEvent } from "@/utils/mixpanel";
import { batch } from "react-redux";

const useContactSales = () => {
  const dispatch = useAppDispatch();
  const isIcpUser = useTypedSelector((state) => state.globalState.isICPUser);

  /**
   * Function to handle the click event for "Contact Sales" button
   * @param entryPoint - The entry point from which the user is contacting sales
   */

  const onContactSales = (entryPoint: string) => {
    trackMixpanelEvent(MIXPANEL_EVENTS.CONTACT_SALES, {
      "Entry Point": entryPoint
    });
    if (isIcpUser) {
      const refactorEntryPoint = entryPoint
        .replace(/-/g, "")
        .toLowerCase()
        .replace(/\s+/g, "-");

      batch(() => {
        dispatch(setCalendlyDialog(true));
        dispatch(
          setCalendlyDialogProps({
            useCase: "Contact Sales",
            utmCampaign: refactorEntryPoint
          })
        );
      });
    } else {
      window.open(CONTACT_SALES_URL, "_blank");
    }
  };

  return {
    onContactSales
  };
};

export default useContactSales;
